module.exports = __webpack_public_path__ + "img/payment.2c463cce.webp";